export default __webpack_public_path__ + "static/img/16.579003b.png";